import request from "../http/request";

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// post 请求参数可以省略data，get请求参数params

// 获取微信授权信息
export const getWXAuthInfor = (data) => {
  return request({
    url: "/userapp/index/WxJsdkTicket",
    method: "POST",
    data: { url: location.href.split("#")[0], ...data },
  });
};

// 获取banner
export const getBanner = () => {
  return request({
    url: "/userapp/banner/list",
    method: "GET",
    params: {
      appType: "U",
    },
  });
};

// 获取用户信息
export const getUserInfo = () => {
  return request({
    url: "/userapp/user/info",
    method: "POST",
  });
};

//获取用户绑定的设备列表
export const getUserDeviceList = () => {
  return request({
    url: "/userapp/terminal",
    method: "GET",
  });
};

//根据sn查询设备信息
export const getDeviceInfo = (data) => {
  return request({
    url: "/userapp/terminal/sn/" + data.sn,
    method: "GET",
  });
};

//根据sn查询设备认证信息
export const getDeviceAuthInfo = (data) => {
  return request({
    url: "/userapp/terminal/sn/isp/" + data.sn,
    method: "GET",
  });
};

//查询联通实名登记信息
export const getChinaUnicomAuthInfo = (data) => {
  return request({
    url: "/userapp/terminal/card/certify/anchor/" + data.iccid,
    method: "GET",
  });
};

//添加设备
export const addDevice = (data) => {
  return request({
    url: "/userapp/terminal/bind",
    method: "POST",
    data,
  });
};

//获取验证码
export const getCode = (data) => {
  return request({
    url: "/userapp/user/sms",
    method: "POST",
    data,
  });
};

//获取设备的详细信息-设备id
export const getDeviceInfoById = (data) => {
  return request({
    url: "/userapp/terminal/" + data.id,
    method: "GET",
    // params: data,
  });
};

//获取流量信息
export const getFlowInfo = (data) => {
  return request({
    url: "/userapp/usage/overview/" + data.id,
    method: "GET",
  });
};

//套餐列表
export const getTrafficPackageList = (data) => {
  return request({
    url: "/userapp/package/list",
    method: "POST",
    data,
  });
};

//获取协议
export const getAgreement = (data) => {
  // platformType 应用端类型：1-微信小程序/APP，2-支付宝小程序
  const defaultParams = {
    platformType: 1,
  };

  return request({
    url: "/userapp/agreement/list",
    method: "POST",
    // data,
    data: {
      ...defaultParams,
      ...data, // 用户传入的参数会覆盖默认参数
    },
  });
};

//获取实名登记卡列表
export const getAuthCardList = (params) => {
  return request({
    url: "/userapp/terminal/certify/card/list",
    method: "GET",
    params,
  });
};

//完成实名登记
export const completeAuth = (data) => {
  return request({
    url: "/userapp/terminal/card/certify/" + data.iccid,
    method: "GET",
  });
};

//获取流量使用统计图
export const getFlowChart = (data) => {
  return request({
    url: "/userapp/usage/graph",
    method: "POST",
    data,
  });
};

//创建订单
export const createOrder = (data) => {
  return request({
    url: "/userapp/order/create",
    method: "POST",
    data,
  });
};

//设备绑定预检查
export const checkDevice = (data) => {
  return request({
    url: "/userapp/terminal/bind/check/" + data.sn,
    method: "GET",
  });
};

//立即领取赠送套餐
export const createFreeOrder = (data) => {
  return request({
    url: "/userapp/order/package/claim",
    method: "POST",
    data,
  });
};

//缴纳押金赠送套餐
export const createDepositOrder = (data) => {
  return request({
    url: "/userapp/order/package/deposit",
    method: "POST",
    data,
  });
};

//其他关联设备预检查
export const checkOtherDevice = (data) => {
  return request({
    url: "/userapp/terminal/other/check",
    method: "GET",
    params: data,
  });
};

//套餐分组列表
export const getGroupTrafficPackageList = (data) => {
  return request({
    url: "/userapp/package/list/group",
    method: "POST",
    data,
  });
};

//创建订单
export const createOtherOrder = (data) => {
  return request({
    url: "/userapp/order/package/supersede",
    method: "POST",
    data,
  });
};

//购买叠加流量包预检查
export const createCheckOrder = (data) => {
  return request({
    url: "/userapp/order/overlay/check/" + data.terminalId,
    method: "GET",
  });
};

//我的套餐列表
export const createGetMyOrder = (data) => {
  return request({
    url: "/userapp/package/list/me/current",
    method: "POST",
    data,
  });
};

//获取WiFi连接信息
export const getWifiInfor = (data) => {
  return request({
    url: "/userapp/terminal/connect/hotspot/" + data.sn,
    method: "GET",
  });
};

//切换网络频段
export const changeNetType = (data) => {
  return request({
    url: "/userapp/terminal/switch/band",
    method: "GET",
    params: data,
  });
};

//无线上网终端集合
export const getWirelessTerminalList = (data) => {
  return request({
    url: "/userapp/wireless/terminal/list",
    method: "GET",
    params: data,
  });
};

//无线上网获取短信验证码
export const getWirelessTerminalSmsCode = (data) => {
  return request({
    url: "/userapp/wireless/send/sms",
    method: "POST",
    data,
  });
};

//无线上网终端登录验证
export const getWirelessTerminalAuth = (data) => {
  return request({
    url: "/userapp/wireless/terminal/auth",
    method: "POST",
    data,
  });
};

//修改备注
export const updateTerminalRemark = (data) => {
  return request({
    url: "/userapp/wireless/modify/remark",
    method: "POST",
    data,
  });
};

//无线上网认证详情
export const getWirelessTerminalInfo = (data) => {
  return request({
    url: "/userapp/wireless/id",
    method: "GET",
    params: data,
  });
};

//获取订单轮巡状态
export const getOrderListDetail = (data) => {
  return request({
    url: "/userapp/order/poll/pay/result",
    method: "GET",
    params: data,
  });
};


//升级套餐列表
export const updateOrderList = (data) => {
  return request({
    url: "/userapp/package/upgrade/list",
    method: "POST",
    data,
  });
};


//套餐升级当前套餐
export const getUpdateUseOrderAction = (data) => {
  return request({
    url: "/userapp/package/upgrade/list/current",
    method: "POST",
    data,
  });
};


//租赁免押激活设备
export const createLeaseFreeActivationDevice = (data) => {
	return request({
		url: "/userapp/order/rent/deposit",
		method: "POST",
		data,
	});
};
// 获取认证状态
export const getWirelessTerminalAuthStatus = (params) => {
	return request({
		url: "/userapp/wireless/terminal/auth/status",
		method: "get",
		params,
	});
};

// 更新无线上网认证状态
export const updateWirelessTerminalAuthStatus = (params) => {
	return request({
		url: "/userapp/wireless/terminal/auth/status/update",
		method: "get",
		params,
	});
};

// 更新实名卡状态
export const updateAuthCardStatus = (params) => {
	return request({
		url: "/userapp/terminal/certify/card/status/" + params.iccid,
		method: "get",
	});
};
